import { asyncSlice } from "./slice";

const initialState = {
  user: null,
};

const authSlice = asyncSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (draft, action) => {
      draft.user = action.payload;
    },
  },
});

const AuthStore = {
  ...authSlice,
  selectors: {
    selectCurrentUser: () => (state) => state.auth.user,
    selectCurrentUserId: () => (state) => state.auth.user?.id,
  },
};

export { AuthStore };
